/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module SC
define(
	'SC.ComponentErrors'
,	[]
,	function()
{
	'use strict';
	
	return {
		
		//@property {Object} notImplemented
		notImplemented: {
			// @property {String} code
			code: 'NOT_IMPLEMENTED'
			// @property {String} message
		,	message: 'Not implemented.'
		}
		
	};
	
});
